import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const PRListCont = styled.div((props) => ({
  marginTop:'1rem',
  // width:'80vw',

  '.ui.table':{
    borderWidth:0
  },

  '.ReactTable .rt-thead.-header':{
    boxShadow:'none',
    background: '#eaeff5'
  },

  '.ReactTable':{
    borderRadius:'0.5rem'
  },

  '.ReactTable .rt-thead .rt-th':{
    borderRight: 0
  },

  '.ReactTable .rt-tbody .rt-td':{
    borderRight: 0
  },

  '.-padRow':{
    cursor:'default !important'
  },

  '.ReactTable .rt-tr':{
    cursor:'pointer'
  },

  '@media only screen and (min-width: 600px)': {
    // width: '100vw',
  },

  '@media only screen and (min-width: 769px)': {
    width: '80vw',
  },

}))

export const StatusTag = styled.div((props) => ({
  fontFamily: 'IBM Plex Sans Thai',
  fontWeight: 'bold',
  fontSize: '0.75rem',
  color: '#FFF',
  padding: '0px 12px',
  background: `${props.status ? v.tagColors[props.status] : v.tagDraft}`,
  width: 'fit-content',
  borderRadius: `${props.allRadius ? '10px' : '10px 0px'}`,
  lineHeight:'1.5em',
  height:'1.5em',
  marginLeft:`${props.marginLeft||0}`
}))

export const DivText = styled.div((props) => ({
  display:'flex',
  justifyContent:`${props.left?'flex-start':'center'}`,

  'div.priority.urgent': {
    background: '#FF0000',
    borderRadius: '2px',
    color: '#FFF',
    fontWeight: 'bold',
    padding: '2px 5px',
  }
}))
